import React, { Dispatch, FC, SetStateAction } from "react";

import { IgSelect } from "@intelligems/ig-theme";
import {
  Divider,
  FormControl,
  ListSubheader,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";

import { orderFiltersByValue } from "../../../../api/formatters/dashboard";
import type {
  BarMetricData,
  LineMetricData,
} from "../../../../types/analytics";

import { GraphConfigGroup, GraphType } from "./graphConfigs";

interface GroupedGraphFilterProps {
  filterChoice: string;
  setFilterChoice: Dispatch<SetStateAction<string>>;
  data: BarMetricData[] | LineMetricData[];
  filterListSubheader?: string;
  filterList?: { id: string; name: string }[];
  config: GraphConfigGroup;
}
export const GroupedGraphFilter: FC<GroupedGraphFilterProps> = ({
  filterChoice,
  setFilterChoice,
  data,
  filterListSubheader,
  config,
  filterList,
}) => {
  const handleChange = (event: SelectChangeEvent<any>) => {
    setFilterChoice(event.target.value as string);
  };

  return (
    <FormControl sx={{ left: -10, width: "100px" }}>
      <IgSelect
        sx={{ height: "25px", fontSize: "12px" }}
        autoWidth={true}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={filterChoice}
        onChange={handleChange}
      >
        {filterListSubheader && (
          <ListSubheader
            color={"inherit"}
            sx={{
              fontSize: "12px",
              width: "150px",
              whiteSpace: "normal",
              lineHeight: "20px",
            }}
          >
            {filterListSubheader}
          </ListSubheader>
        )}
        <Divider />
        {filterList
          ? filterList.map((filterItem) => (
              <MenuItem
                sx={{
                  width: "150px",
                  whiteSpace: "normal",
                  lineHeight: "15px",
                  fontSize: "12px",
                }}
                disableTouchRipple={true}
                dense
                key={filterItem.id}
                value={filterItem.id}
              >
                {filterItem.name}
              </MenuItem>
            ))
          : config.configs[0].graphType === GraphType.Bar ||
              config.configs[0].graphType === GraphType.SyncedBar
            ? orderFiltersByValue(data as BarMetricData[]).map((filter) => (
                <MenuItem
                  sx={{
                    width: "150px",
                    whiteSpace: "normal",
                    lineHeight: "15px",
                    fontSize: "12px",
                  }}
                  disableTouchRipple={true}
                  dense
                  key={filter.filterMethod}
                  value={filter.filterMethod}
                >
                  {filter.filterMethod}
                </MenuItem>
              ))
            : null}
      </IgSelect>
    </FormControl>
  );
};
